import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { ProgramacaoDetail } from '../types'
import { programacoesRepository } from './programacaoRepository'

export const useProgramacao = makeUseFetchOne<ProgramacaoDetail, string>({
  fetch: programacoesRepository.fetchOne
})
